import * as moment from 'moment';
import {SERVER_DATE_FORMAT_WITHOUT_TIME} from '../config/date_format';
import {FuseConfig} from '../../@fuse/types';
import {fuseConfig} from '../fuse-config';
import {fuseConfig_qalqul_theme} from '../fuse-config/qalqul-theme';
import {fuseConfig_robimotion_theme} from '../fuse-config/robimotion-theme';
import {MappedMarket} from '../dto/mapped-market';

export function getEnumSelector(pTargetEnum: any): { title: string; value: any, selected: boolean }[] {
    return Object.keys(pTargetEnum).map(pKey => ({value: pKey, title: pTargetEnum[pKey], selected: false}));
}

export function findEnum(pTargetEnum: any, pTargetKey: string): string {
    return Object.keys(pTargetEnum).filter(pKey => pTargetEnum[pKey] === pTargetKey)[0];
}

export function padString(pInputString: string, pPadString: string, pLength: number, pLeft = true): string {
    return pLeft ? pInputString.padStart(pLength, pPadString) : pInputString.padEnd(pLength, pPadString);
}

export function arrayRemove(pArray: any[], pItem: any): any[] {
    const index = pArray.indexOf(pItem);
    if (index > -1) {
        pArray.splice(index, 1);
    }
    return pArray;
}

export function getDaysInMonth(month, year): number {
    return new Date(year, month, 0).getDate();
}

export function getOrganizationLogoName(pOrgCode: string): string {
    let imagePath = 'biz_motion.png';

    const siteLink = window.location.href;
    if (siteLink.includes('robisfaplusg2.robimotion.com') || siteLink.includes('sfaplus.robisfa.com') ) {
        return 'assets/images/logos/robi.png';
    }

    if (pOrgCode != null) {
        if (pOrgCode.toUpperCase() === 'MUNDI') {
            imagePath = 'mundi.png';
        } else if (pOrgCode.toUpperCase() === 'RNG') {
            imagePath = 'rangs.png';
        } else if (pOrgCode.toUpperCase() === 'BIO') {
            imagePath = 'biopharma.png';
        } else if (pOrgCode.toUpperCase() === 'SMC') {
            imagePath = 'smcpharma.png';
        } else if (pOrgCode.toUpperCase() === 'ALBN') {
            imagePath = 'albion-org-432.png';
        } else if (pOrgCode.toUpperCase() === 'STEC') {
            imagePath = 'somatec.png';
        } else if (pOrgCode.toUpperCase() === 'AUS') {
            imagePath = 'auspicious.png';
        } else if (pOrgCode.toUpperCase() === 'EVST') {
            imagePath = 'everest.png';
        } else if (pOrgCode.toUpperCase() === 'SEL') {
            imagePath = 'sel.png';
        } else if (pOrgCode.toUpperCase() === 'SHARIF') {
            imagePath = 'sharif.png';
        } else if (pOrgCode.toUpperCase() === 'LABAID') {
            imagePath = 'labaid.png';
        } else if (pOrgCode.toUpperCase() === 'DBLP') {
            imagePath = 'dblpharma.png';
        } else if (pOrgCode.toUpperCase() === 'MSHISHU') {
            imagePath = 'mshishu.png';
        } else if (pOrgCode.toUpperCase() === 'GOODMAN') {
            imagePath = 'goodman.png';
        } else if (pOrgCode.toUpperCase() === 'JIBON') {
            imagePath = 'jibonalo.png';
        }
    }
    return imagePath;
}

export function getOrganizationTheme(pOrgCode: string): FuseConfig {
    let fuseConf = fuseConfig;
    if (pOrgCode == null) {
        return fuseConf;
    } else if (pOrgCode === 'qalqul') {
        fuseConf = fuseConfig_qalqul_theme;
    }
    else if (window.location.href.includes('robimotion') || window.location.href.includes('robisfa')){
        fuseConf = fuseConfig_robimotion_theme;
    }
    return fuseConf;
}

export function getDatesInBetween(pStartDate: string, pEndDate: string): string[] {
    const dates: string[] = [];
    const currentDate = moment(pStartDate).startOf('day');
    const endDate = moment(pEndDate).startOf('day');

    while (currentDate.diff(endDate) <= 0) {
        dates.push(currentDate.clone().format(SERVER_DATE_FORMAT_WITHOUT_TIME));
        currentDate.add(1, 'days');
    }

    return dates;
}

export function getEnumTitle(pEnum, pValue) {
    if (pValue) {
        return pEnum[pValue];
    } else {
        return `N/A`
    }
}

export function setText(property) {
    if (property) {
        return property;
    } else {
        return `N/A`;
    }
}

export function checkValidArray(property): boolean {
    return property && property.length > 0;
}

export function prepareMarketForList(market: MappedMarket) {
    return {
        id: market.Id,
        name: market.Name,
        code: market.Code,
        marketLevel: market.MarketLevel
    }
}

export function prepareSalesCenter(market: MappedMarket) {
    return {
        id: market.SalesCenter.Id,
        name: market.SalesCenter.Name,
        code: market.SalesCenter.Code
    }
}

export function prepareObject(pObject: Object): Object {
    const newObject = {...pObject};
    Object.keys(newObject).forEach(pKey => {
        if (newObject[pKey] == null || newObject[pKey] == 'null' || newObject[pKey] == undefined) {
            delete newObject[pKey];
        }
    });
    return newObject;
}